import { ProductPreviewCard } from "@/components/cards/product-preview-card";
import { TipCard } from "@/components/cards/tip-card";
import { useProductEdit } from "@/hooks/products/useProductEdit";
import ProductFormCard from "@/pages/adicionar-produtos/(components)/product-form-card";
import type { ProductFormValues } from "@/pages/adicionar-produtos/types";
import { Loading } from "@uigovpe/components";
import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";

export default function EditProduct() {
  const { id } = useParams();
  const productId = Number(id);
  const {
    businessName,
    error,
    initialProduct,
    initialValues,
    isLoading,
    loadProduct,
  } = useProductEdit();
  const [preview, setPreview] = useState<ProductFormValues | null>(null);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  useEffect(() => {
    if (Number.isInteger(productId) && productId > 0)
      void loadProduct(productId).catch(() => undefined);
  }, [loadProduct, productId]);
  useEffect(() => {
    if (initialValues) setPreview(initialValues);
  }, [initialValues]);
  if (!Number.isInteger(productId) || productId <= 0)
    return <Navigate to="/my-products" replace />;
  if (isLoading || !initialValues || !initialProduct || !preview)
    return error ? (
      <main className="p-5! text-sm! text-zinc-700!">{error}</main>
    ) : (
      <div
        className="flex! min-h-[320px]! w-full! items-center! justify-center!"
        role="status"
      >
        <Loading />
        <span className="sr-only">Carregando produto...</span>
      </div>
    );
  return (
    <main className="min-h-0! w-full! min-w-0! p-5!">
      {isLoadingCategories && (
        <div
          className="flex! min-h-[320px]! w-full! items-center! justify-center!"
          role="status"
          aria-live="polite"
          aria-label="Carregando categorias"
        >
          <Loading />
          <span className="sr-only">Carregando categorias...</span>
        </div>
      )}
      <div
        className={`${isLoadingCategories ? "hidden!" : "flex!"} w-full! items-start! gap-5!`}
      >
        <div className="min-w-0! flex-1! lg:flex-[2.3]!">
          <ProductFormCard
            mode="edit"
            productId={productId}
            initialValues={initialValues}
            initialProduct={initialProduct}
            onValuesChange={setPreview}
            onCategoriesLoadingChange={setIsLoadingCategories}
          />
        </div>
        <aside className="hidden! flex-[0.7]! pt-[60px]! lg:block!">
          <div className="sticky! top-5! ml-auto! flex! w-full! max-w-[360px]! flex-col! gap-5!">
            <ProductPreviewCard
              data={{
                name: preview.name,
                description: preview.description,
                mainImageUrl: preview.mainImage?.url,
                keywords: preview.keywords,
                category: preview.categoryLabel,
                subcategory: preview.subcategoryLabel,
                businessName,
              }}
            />
            <TipCard
              title="Dica para você"
              description="Revise as informações antes de salvar as alterações do produto."
              className="w-full!"
            />
          </div>
        </aside>
      </div>
    </main>
  );
}
